import { render, staticRenderFns } from "./BaseFrontOfficeChip.vue?vue&type=template&id=c10f2b14&scoped=true"
import script from "./BaseFrontOfficeChip.vue?vue&type=script&lang=js"
export * from "./BaseFrontOfficeChip.vue?vue&type=script&lang=js"
import style0 from "./BaseFrontOfficeChip.vue?vue&type=style&index=0&id=c10f2b14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c10f2b14",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
